import { MigrationPage } from "../MigrationPage";

const DataFreshness = (): JSX.Element => (
  <MigrationPage title="Data Freshness" pageType="Data Freshness" />
);

export default DataFreshness;
